import styled from 'styled-components';
import Modal from '@material-ui/core/Modal';
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';

const ContentContainer = styled(Box)`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100vw;
    max-height: 100vh;
    outline: 0;
`;

const InnerContainer = styled.div`
    max-width: 96vw;
    max-height: 96vh;
`;

const CloseButton = styled.div`
    position: absolute;
    top: 20px;
    right: 20px;
    /* pointer-events: none; */
    color: #ffffff;

    &:hover {
        cursor: pointer;
    }
`;

const Popup = ({ children, closeOnClick = false, ...props }) => {
    return (
        <Modal {...props}>
            <>
                <ContentContainer onClick={closeOnClick ? props.onClose : null}>
                    <InnerContainer>{children}</InnerContainer>
                </ContentContainer>
                <CloseButton onClick={props.onClose}>
                    <CloseIcon />
                </CloseButton>
            </>
        </Modal>
    );
};

export default Popup;
